import '@treasury/presentation/components/tm-button';
import { html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { TmBaseComponent } from '../tm-base.component';

export const tagName = 'tm-toggle-content';
@customElement(tagName)
export class TmToggleContent extends TmBaseComponent {
    @property({ type: String })
    public buttonType?: 'primary' | 'secondary' | 'tertiary' = 'tertiary';

    @property({ type: String })
    public label = 'options';

    @property()
    public defaultState = false;

    @state()
    private showContent = false;

    protected firstUpdated() {
        this.showContent = this.defaultState;
    }

    protected render() {
        if (!this.showContent) {
            return html`<tm-button
                class=${classMap({
                    'my-1': true,
                    'ml-3': this.buttonType === 'tertiary',
                })}
                importance=${ifDefined(this.buttonType)}
                @click=${() => {
                    this.showContent = true;
                }}
                >Show ${this.label}</tm-button
            >`;
        }
        return html`
            <div><slot></slot></div>
            <tm-button
                class=${classMap({
                    'my-1': true,
                    'ml-3': this.buttonType === 'tertiary',
                })}
                importance=${ifDefined(this.buttonType)}
                @click=${() => {
                    this.showContent = false;
                }}
                >Hide ${this.label}</tm-button
            >
        `;
    }
}
declare global {
    interface HTMLElementTagNameMap {
        [tagName]: TmToggleContent;
    }
}
